module.exports = __webpack_public_path__ + "img/brand-marjo.a156baa6.png";